import { useCallback } from 'react';

import { toast } from 'sonner';

import { DocumentZipEvent, useDocumentZipEvents } from './useDocumentZipEvents';

interface UseEmailAttachmentWarningsProps {
  caseId: string;
  enabled?: boolean;
}

export const useEmailAttachmentWarnings = ({ caseId, enabled = true }: UseEmailAttachmentWarningsProps) => {
  const handleEvent = useCallback((event: DocumentZipEvent) => {
    if (event.type === 'email-attachment-warning' && event.unsupportedAttachments && event.parentEmailName) {
      const attachmentCount = event.unsupportedAttachments.length;

      const attachmentNames = event.unsupportedAttachments.map((a) => a.filename).join(', ');
      const attachmentText = attachmentCount === 1 ? 'attachment' : 'attachments';

      toast.warning(
        `Email ${attachmentText} ${attachmentNames} from '${event.parentEmailName}' ${attachmentCount === 1 ? 'is' : 'are'} not supported and will be ignored`,
        {
          duration: 8000,
          position: 'bottom-right',
        },
      );
    }
  }, []);

  const { disconnect } = useDocumentZipEvents({
    caseId,
    enabled,
    onEvent: handleEvent,
  });

  return { disconnect };
};
